/**
 * DNA分析相关js
 */
import sequenceCommon from "./sequenceCommon"; // 序列操作公共js方法
const dnaAnalysisUtils = {
  // 蛋白质翻译链判断map
  abbreviation : {
    ATA: "I",ATC: "I",ATT: "I",ATG: "M",ACA: "T",ACC: "T",ACG: "T",ACT: "T",
    AAC: "N",AAT: "N",AAA: "K",AAG: "K",AGC: "S",AGT: "S",AGA: "R",AGG: "R",
    CTA: "L",CTC: "L",CTG: "L",CTT: "L",CCA: "P",CCC: "P",CCG: "P",CCT: "P",
    CAC: "H",CAT: "H",CAA: "Q",CAG: "Q",CGA: "R",CGC: "R",CGG: "R",CGT: "R",
    GTA: "V",GTC: "V",GTG: "V",GTT: "V",GCA: "A",GCC: "A",GCG: "A",GCT: "A",
    GAC: "D",GAT: "D", GAA: "E",GAG: "E",GGA: "G",GGC: "G",GGG: "G",GGT: "G",
    TCA: "S",TCC: "S",TCG: "S",TCT: "S",TTC: "F",TTT: "F",TTA: "L",TTG: "L",
    TAC: "Y", TAT: "Y", TAA: "*", TAG: "*",TGA: "*",TGC: "C",TGT: "C",TGG: "W"
  },
  // 酶切点判断数组
  restrictionList: [/^GACGTC$/i, /^GT[ac][gt]AC$/i, /^CCGC$/i, /^AACGTT$/i, /^CTGAAG$/i, /^AGCGCT$/i, /^CTTAAG$/i, /^ACCGGT$/i, /^gac[acgt]{5}gtc$/i, /^cac[acgt]{4}gtg$/i, /^AGCT$/i, /^ggatc[acgt]{4}$/i, /^cag[A-Z]{3}ctg$/i, /^gggccc$/i, /^gtgcac$/i, /^Gc[at]gc$/i, /^[ag]aatt[ct]$/i, /^ggcgcgcc$/i, /^attaat$/i, /^gcgatcgc$/i, /^c[CT]cg[AG]g$/i, /^gg[AT]cc$/i, /^cctagg$/i, /^[acgt]{10}ac[acgt]{4}gta[ct]c[acgt]{12}$/, /^ggatcc$/i, /^gg[ct][ag]cc$/i, /^g[ag]gc[ct]c$/i, /^caagac$/i, /^cctcagc$/i, /^gcagc[acgt]{8}$/i, /^acggc[acgt]{12}$/i, /^gtatcc[acgt]{6}$/, /^ccatc[acgt]{4}$/i, /^tgatca$/i, /^actggg[acgt]{5}$/i, /^ctag$/i, /^gtatcc$/i, /^gcc[acgt]{5}ggc$/i, /^agatct$/i, /^gct[acgt]agc$/i, /^cacgtc$/i, /^g[gt]gc[ac]c$/i, /^gctagc$/i, /^ctggag$/i, /^cct[acgt]agc$/i, /^cttgag$/i, /^[ct]acgt[ag]$/i, /^gat[acgt]{4}atc$/i, /^g[ag]cg[ct]c$/i, /^ggtctc$/i, /^cgtacg$/i, /^cc[acgt]{7}gg$/i, /^cgrcrc$/i, /^gggac$/i, /^g[agt]gc[act]c$/i, /^ctcag$/i, /^tcatga$/i, /^acctgc$/i, /^ccgctc$/i, /^[ag]ccgg[ct]$/i, /^gcgcgc$/i, /^cca[acgt]{6}tg$/i, /^cct[acgt]agg$/i, /^atcgat$/i, /^gaattc$/i, /^ggcc$/i, /^aagctt$/i, /^ggtacc$/i, /^acgcgt$/i, /^ccatgg$/i, /^catatg$/i, /^gctagc$/i, /^gcggccgc$/i, /^atgcat$/i, /^ttaattaa$/i, /^gtttaaac$/i, /^ctgcag$/i, /^cgatcg$/i, /^gagctc$/i, /^ccgcgg$/i, /^gtcgac$/i, /^agtact$/i, /^cccggg$/i, /^actagt$/i, /^gcatgc$/i, /^aggcct$/i],
  // 酶切位点名称数组
  restrictionNameList: ["AatII", "AccI", "AciI", "AclI", "AcuI", "AfeI", "AflII", "AgeI", "AhdI", "AleI", "AluI", "AlwI", "AlwNI", "ApaI", "ApaLI", "ApeKI", "ApoI", "AscI", "AseI", "AsiSI", "AvaI", "AvaII", "AvrII", "BaeI", "BamHI", "BanI", "BanII", "BbsI", "BbvCI", "BbvI", "BceAI", "BciVI", "BccI", "BclI", "BmrI", "BfaI", "BfuI", "BglI", "BglII", "BlpI", "BmgBI", "Bme1580I", "BmtI", "BpmI", "Bpu10I", "BpuEI", "BsaAI", "BsaBI", "BsaHI", "BsaI", "BsiWI", "BslI", "BsmBI", "BsmFI", "Bsp1286I", "BspCNI", "BspHI", "BspMI", "BsrBI", "BsrFI", "BssHII", "BstXI", "Bsu36I", "ClaI", "EcoRI", "HaeIII", "HindIII", "KpnI", "MluI", "NcoI", "NdeI", "NheI", "NotI", "NsiI", "PacI", "PmeI", "PstI", "PvuI", "SacI", "SacII", "SalI", "ScaI", "SmaI", "SpeI", "SphI", "StuI"],
  /**
   * DNA性质分析
   */
  DNApropertiesFunction() {
    const legalCharArr = ["A", "T", "G", "C", "W", "S", "R", "Y", "K", "M", "B", "D", "H", "V", "N", "-"];
    const instance = this.instance;
    const selectedRangeArr = instance.api.getRangeArray('twoDimensional');
    if (selectedRangeArr.length > 0) {
      let range = instance.api.getRange();
      let rowIndex = range[range.length - 1].row[0] // 行第一次取值
      let colIndex = range[range.length - 1].column[0] // 列第一次取值
      selectedRangeArr.forEach((selectedRangeArrItem) => { // 遍历取的行
        let selectedRangeStr = selectedRangeArrItem.filter(item => item).join('').toUpperCase()
        const f = /[0-9]+/
        if (selectedRangeStr !== '' && !!0 == f.test(selectedRangeStr)) { // 如果取值为空，说有选中有空行。 如果正则表达式筛选为false，说明有非法字符串
          instance.api.insertRow(rowIndex + 1)
          let sequenceLength = 0
          let atNum = 0 // A+T数量
          let gcNum = 0 // G+C数量
          selectedRangeStr.split('').forEach(item => { // 遍历累加AT/GC,其他若是正常字符中非ATGC 则AT+1
            if (item === 'A' || item === 'T') {
              atNum++
            } else if (item === 'G' || item === 'C') {
              gcNum++
            } else {
              if (legalCharArr.includes(item)) {
                atNum++
              }
            }
          })
          sequenceLength = atNum + gcNum
          let tm = ''
          if (sequenceLength <= 13) { // 计算公式
            // Tm = 4 * (G + T) + 2 * (A + T)
            tm = (4 * (gcNum) + 2 * (atNum)).toFixed(1)
          } else {
            // TM= 64.9 + 41*(G+C-16.4)/(A+T+G+C) G、C、A、T分别表示引物中G、C、A、T的个数
            tm = (64.9 + 41 * (gcNum - 16.4) / (atNum + gcNum)).toFixed(1)
          }
          let gc = ((gcNum) / sequenceLength * 100).toFixed(2)
          let data = `Tm:${tm}℃ GC (%):${gc} Sequence length:${sequenceLength}`
          instance.api.setRangeValue([[data]], { range: { column: [colIndex, colIndex], row: [rowIndex + 1, rowIndex + 1] } })
          rowIndex = rowIndex + 2 // 多行时的累加
        } else {
          rowIndex = rowIndex + 1 // 多行时空白行累加
        }
      });
      instance.api.setRangeShow(range);
    }
  },
  /**
   * 互补链计算
   */
  complementaryChainComputing() {
    const instance = this.instance;
    const selectedRangeArr = instance.api.getRangeArray('twoDimensional');
    if (selectedRangeArr.length > 0) {
      const range = instance.api.getRange();
      let rowIndex = range[range.length - 1].row[0] // 行第一次取值
      let colIndex = range[range.length - 1].column // 列第一次取值
      selectedRangeArr.forEach((selectedRangeArrItem) => { // 遍历取的行
        let selectedRangeStr = selectedRangeArrItem.filter(item => item).join('')
        const mumRep = /[0-9]+/
        if (selectedRangeStr !== '' && !!0 == mumRep.test(selectedRangeStr)) { // 如果取值为空，说有选中有空行。 如果正则表达式筛选为false，说明有非法字符串
          instance.api.insertRow(rowIndex + 1)
          const baseComplementarity = { // 符合互补链规则的字母
            A: 'T',
            T: 'A',
            C: 'G',
            G: 'C',
            a: 't',
            t: 'a',
            c: 'g',
            g: 'c',
          }
          let data = ['互补链：']
          const complementary = [...selectedRangeStr]
          complementary.forEach(item => {
            if (baseComplementarity[item] !== undefined) { // 不在互补规则内则不为列增加信息
              data.push(baseComplementarity[item])
            }
          })
          instance.api.setRangeValue([data], { range: { column: [colIndex[0] - 1, colIndex[0] + data.length - 2], row: [rowIndex + 1, rowIndex + 1] } })
          rowIndex = rowIndex + 2 // 多行时的累加
        } else {
          rowIndex = rowIndex + 1 // 多行时空白行累加
        }
      });
      instance.api.setRangeShow(range);
    }
  },
  
  /**
   * 翻译为正链
   */
  translateProteinForwardStrand: function(){
    const instance = this.instance;
    const containerId = instance.getInstanceId();
    const range = luckysheet[containerId].getRange()
    let rowIndex = range[range.length - 1].row // 行第一次取值
    let colIndex = range[range.length - 1].column // 列第一次取值
    let selectedRangeArr = luckysheet[containerId].getRangeArray('twoDimensional')
    let l = [],f = [], h = []; // l为存储翻译后内容 f为内容长度
    if(selectedRangeArr.length > 0){ // 如果选中行有内容
      for(let i = 0; i < selectedRangeArr.length; i++){ // 循环读取选中行
        let p = selectedRangeArr[i].filter(item => item).join('').toUpperCase() // 读取当前行的全部内容转为字符串
        "" !== p ? l.push(p) : l.push("*") // 如果当前行为空字符串则赋值为*
        let m = 0, y = 0;
        for ( let g = 0; g < selectedRangeArr[i].length; g++ ) { //循环读取为正确规则的字符
          let v = selectedRangeArr[i][g];
          v && void 0 !== v || 0 !== y || m++,
          v && y++
        }
        var b = colIndex[1] - colIndex[0] + 1 - m - y;
        f.push(m),
        h.push(b)
      }
      let x = 0
      for (let w = 0; w < rowIndex[1] - rowIndex[0] + 1; w++){ // 判断是否为第一列，都则赋值X为1用于插入列
        0 === colIndex[0] && 0 === f[w] && (x = 1);
      }
      let row = rowIndex[0]                  
      for (let S = 0; S < rowIndex[1] - rowIndex[0] + 1; S++) {
        D(rowIndex[0] + 2 * S + 1, 1); // 插入行
        // 累加列数，用于插入数据
        let O = colIndex[0] - 1 + f[S]
          , C = O + l[S].length + 1;
        1 === x && (0 === S && M(colIndex[0]),
        O++,
        C++),
        luckysheet[containerId].setRangeFormat("bg", "#f8e0e6", { range: { column: [O, O], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) // 插入开始背景色
        luckysheet[containerId].setRangeValue([['>']], { range: { column: [O, O], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) // 插入正链开始标识字符
        luckysheet[containerId].setRangeFormat("bg", "#f8e0e6", { range: { column: [C, C], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) // 插入结束背景色
        luckysheet[containerId].setRangeValue([['>']], { range: { column: [C, C], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) //插入正链 结束标识字符
        let col = O
        for (let k = 0; k < l[S].length - 2; k += 3) { // 合并列并填入翻译后数据
            let T = l[S][k].toUpperCase()
              , A = l[S][k + 1].toUpperCase()
              , I = l[S][k + 2].toUpperCase();
            if (void 0 !== T && void 0 !== A && void 0 !== I && T && A && I && "-" !== (T || A || I) && _(T) && _(A) && _(I)) {
                let N = [T, A, I].join("").toUpperCase();
                if (N && void 0 !== N) {
                    let j = this.abbreviation[N]
                    luckysheet[containerId].cancelRangeMerge({ range: { column:[col+1, col+3], row: [row + 1, row + 1]} }) // 避免bug，先取消当前单元格的合并列
                    luckysheet[containerId].setRangeMerge("all",{ range: { column:[col+1, col+3], row: [row + 1, row + 1]} }) // 合并单元格
                    luckysheet[containerId].setRangeValue([[j]], { range: { column: [col+1, col+1], row: [row + 1, row + 1] } }) //填入数据
                    col = col + 3
                }
            }
        }
        if(l[S] === "*"){ // 如果当前行为空数据，填入*数据
          luckysheet[containerId].setRangeValue([[l[S]]], { range: { column: [col+1, col+1], row: [row, row] } })
        }
        row = row + 2
      }
      instance.api.setRangeShow(range);
    }
    /**
     * 插入新列
     * @param {插入列} start 
     */
    function M(start){
      luckysheet[containerId].insertColumn(start)
    }
    /**
     * 插入新行
     * @param {插入行} start 
     * @param {插入的条数} num 
     */
    function D(start, num){
      luckysheet[containerId].insertRow(start,{number:num})
    }
  },

  /**
   * 翻译为负链
   */
  translateProteinReverseStrand: function(){
    let instance = this.instance;
    let containerId = instance.getInstanceId();
    const baseComplementarity = { // 符合互补链规则的字母
      A: 'T',
      T: 'A',
      C: 'G',
      G: 'C',
    }
    const range = luckysheet[containerId].getRange()
    let rowIndex = range[range.length - 1].row // 行第一次取值
    let colIndex = range[range.length - 1].column // 列第一次取值
    let selectedRangeArr = luckysheet[containerId].getRangeArray('twoDimensional')
    let l = [],f = [], h = []; // l为存储翻译后内容 f为内容长度
    if(selectedRangeArr.length > 0){ // 如果选中行有内容
      for(let i = 0; i < selectedRangeArr.length; i++){ // 循环读取选中行
        let p = selectedRangeArr[i].filter(item => item).join('').toUpperCase() // 读取当前行的全部内容转为字符串
        "" !== p ? l.push(p) : l.push("*") // 如果当前行为空字符串则赋值为*
        let m = 0, y = 0;
        for ( let g = 0; g < selectedRangeArr[i].length; g++ ) { //循环读取为正确规则的字符
          let v = selectedRangeArr[i][g];
          v && void 0 !== v || 0 !== y || m++,
          v && y++
        }
        var b = colIndex[1] - colIndex[0] + 1 - m - y;
        f.push(m),
        h.push(b)
      }
      let x = 0
      for (let w = 0; w < rowIndex[1] - rowIndex[0] + 1; w++){ // 判断是否为第一列，都则赋值X为1用于插入列
        0 === colIndex[0] && 0 === f[w] && (x = 1);
      }
      let row = rowIndex[0]                  
      for (let S = 0; S < rowIndex[1] - rowIndex[0] + 1; S++) {
        D(rowIndex[0] + 2 * S + 1, 1); // 插入行
        // 累加列数，用于插入数据
        let O = colIndex[0] - 1 + f[S]
          , C = O + l[S].length + 1;
        1 === x && (0 === S && M(colIndex[0]),
        O++,
        C++),
        luckysheet[containerId].setRangeFormat("bg", "#E0F8E0", { range: { column: [O, O], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) // 插入开始背景色
        luckysheet[containerId].setRangeValue([['<']], { range: { column: [O, O], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) // 插入负链开始标识字符
        luckysheet[containerId].setRangeFormat("bg", "#E0F8E0", { range: { column: [C, C], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) // 插入结束背景色
        luckysheet[containerId].setRangeValue([['<']], { range: { column: [C, C], row: [rowIndex[0] + 2 * S + 1, rowIndex[0] + 2 * S + 1] } }) //插入负链 结束标识字符
        let col = C
        for (let k = 0; k < l[S].length - 2; k += 3) { // 合并列并填入翻译后数据
            let T = l[S][l[S].length - k - 1].toUpperCase()
              , A = l[S][l[S].length - k - 2].toUpperCase()
              , I = l[S][l[S].length - k - 3].toUpperCase()
            if(baseComplementarity[T]!==undefined && baseComplementarity[A]!==undefined && baseComplementarity[I]!==undefined){ // 转义为负链 
              T = baseComplementarity[T]
              A = baseComplementarity[A]
              I = baseComplementarity[I]
            }
            if (void 0 !== T && void 0 !== A && void 0 !== I && T && A && I && _(T) && _(A) && _(I)) {
                let N = [T, A, I].join("").toUpperCase();;
                if (N && void 0 !== N) {
                    let j = this.abbreviation[N]
                    luckysheet[containerId].cancelRangeMerge({ range: { column:[col-3, col-1], row: [row + 1, row + 1]} }) // 避免bug，先取消当前单元格的合并列
                    luckysheet[containerId].setRangeMerge("all",{ range: { column:[col-3, col-1], row: [row + 1, row + 1]} }) // 合并单元格
                    luckysheet[containerId].setRangeValue([[j]], { range: { column: [col-3, col-3], row: [row + 1, row + 1] } }) //填入数据
                    col = col - 3
                }
            }
        }
        if(l[S] === "*"){ // 如果当前行为空数据，填入*数据
          luckysheet[containerId].setRangeValue([[l[S]]], { range: { column: [col-1, col-1], row: [row, row] } })
        }
        row = row + 2
      }
      instance.api.setRangeShow(range);
    }
    /**
     * 插入新列
     * @param {插入列} start 
     */
    function M(start){
      luckysheet[containerId].insertColumn(start)
    }
     /**
     * 插入新行
     * @param {插入行} start 
     * @param {插入的条数} num 
     */
    function D(start, num){
      luckysheet[containerId].insertRow(start,{number:num})
    }
  },
  /**
   * DNA双序列对比
   */
  doubleSequenceComparison: function(){
    let instance = this.instance;
    let containerId = instance.getInstanceId();
    let currentInstance = $(`#${containerId}`);
    let Store = instance.getStore();
    let _locale = instance.locale();
    const locale_dnaAnalysis = _locale.dnaAnalysis;
    const proteinanalysismenuText = _locale.proteinanalysismenu;
    const maskDialog =  currentInstance.find("#luckysheet-modal-dialog-mask");
    let t = 0;
    // 弹框内容
    let content = `<div class="proteinanalysis-setting-block blastp-block">
      <div class="subtemplate_wrap">
        <div id="sub_module_body">
          <div id="save_as_box" class="save_as_box">
            <div class="range-input">
              <span>${proteinanalysismenuText.sequence1}</span>
              <input type="text" class="sequenceRange1" placeholder="${proteinanalysismenuText.placeholder.sequenceSelect}" />
              <i class="range-input-icon"></i>
            </div>
            <div class="range-input">
              <span>${proteinanalysismenuText.sequence2}</span>
              <input type="text" class="sequenceRange2" placeholder="${proteinanalysismenuText.placeholder.sequenceSelect1}" />
              <i class="range-input-icon"></i>
            </div>
            <div class="range-input">
              <span>${proteinanalysismenuText.selectOput}</span>
              <input type="text" class="sequenceRange3" placeholder="${proteinanalysismenuText.placeholder.selectOputTip}" value="A3"/>
              <i class="range-input-icon-output"></i>
            </div>
            <div class="save_part config-match">
              <label>${proteinanalysismenuText.DnaMatch}：</label>
              <select class="MatchSelect" >
                <option value="3" selected>3</option>           
                <option value="2">2</option>       
                <option value="1">1</option>      
                <option value="0">0</option>
              </select>
            </div>
            <div class="save_part config-dismatch">
              <label>${proteinanalysismenuText.DnaDismatch}：</label>
              <select class="MatchSelect" >
                <option value="-3" selected>-3</option>            
                <option value="-2">-2</option>              
                <option value="-1">-1</option>           
                <option value="0">0</option>
              </select>
            </div>
            <div class="save_part config-DnaGap">
              <label>${proteinanalysismenuText.gapcosts}：</label>
              <select class="select_gapcosts" >
                <option value="-4,-4" selected>Existence:4 Extension:4</option>           
                <option value="-2,-4">Existence:2 Extension:4</option>
                <option value="0,-4">Existence:0 Extension:4</option>
                <option value="-3,-3">Existence:3 Extension:3</option>
                <option value="-6,-2">Existence:6 Extension:2</option>              
                <option value="-5,-2">Existence:5 Extension:2</option>              
                <option value="-4,-2">Existence:4 Extension:2</option>             
                <option value="-2,-2">Existence:2 Extension:2</option>
              </select>
            </div>
            <div class="save_part">
              <span>${proteinanalysismenuText.placeholder.compareTips}</span>
            </div>
          </div>
        </div>
      </div>
    </div>`;
    const self = this;
    // 计算弹窗确定 回调函数
    let confirmCallback = function (target, instance) {
      let seqDialog = currentInstance.find(`#${id}`);
      let e, t;
      const range = instance.api.getRange();
      let r = []
        , o = parseInt(seqDialog.find(".config-match select").val())
        , a = parseInt(seqDialog.find(".config-dismatch select").val())
        , s = seqDialog.find(".config-DnaGap select").val()
        , c = seqDialog.find(".sequenceRange1").val().split(":")
        , u = seqDialog.find(".sequenceRange2").val().split(":")
        , l = seqDialog.find(".sequenceRange3").val()
        , h = 0
        , m = 0
        , y = sequenceCommon.rangeEasilyOutput(c, instance)
        , g = sequenceCommon.rangeEasilyOutput(u, instance)
        , v = /[#]/;
      if (c.length > 0 && u.length > 0) {
        for (let b = y[0]; b <= y[2]; b++) {
          let x = "";
          for (let w = y[1]; w <= y[3]; w++) {
            let _ = (instance.api.getCellValue(b, w) || '').toString().replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/[\n\r]/g, "");;
            !1 === v.test(_) && "" !== _ && (x += _)
          }
          if ("" !== x) r.push(x);
        }
        for (let S = g[0]; S <= g[2]; S++) {
          let E = "";
          for (let C = g[1]; C <= g[3]; C++) {
            let k = (instance.api.getCellValue(S, C) || '').toString().replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/[\n\r]/g, "").replace(/\*/g, "");
            if (!1 === v.test(k) && "" !== k) (E += k);
          }
          if ("" !== E) r.push(E);
        }
        e = r[0],
        h = sequenceCommon.computeRange(l, instance)[0] - 1,
        m = sequenceCommon.computeRange(l, instance)[1] - 1;
        // 输出标题信息
        instance.api.setCellValue(m, h, "NW Score:"),
        instance.api.setCellValue(m, h + 1, "Identifies:"),
        instance.api.setCellValue(m, h + 2, "Gaps:");
        for (let M = 1; M < r.length; M++) {
          if ((t = r[M]).length > 0 && e.length > 0) {
            let T = self.getMatrix(e, t, o, a, parseInt(s.split(",")[0]), parseInt(s.split(",")[1]))
              , A = self.getSequenceList(e, t, T)
              , I = A[0].length;
            // 插入序列对比要占用的行数
            sequenceCommon.insertSheetRow(m + 1, 5, instance);
            // 输入双序列对比数据
            for (let N = 0; N < A[0].length; N++) {
              instance.api.setCellValue(m, h + N + 3, A[0][N].toUpperCase(), { isRefresh: false });
              instance.api.setCellValue(m + 2, h + N + 3, A[1][N].toUpperCase(), { isRefresh: false });
              if (A[1][N] === A[0][N]) {
                instance.api.setCellValue(m + 1, h + N + 3, "|", { isRefresh: false });
              } else {
                instance.api.setCellValue(m + 1, h + N + 3, "", { isRefresh: false });
                if ("-" !== A[1][N]) {
                  instance.api.setCellValue(m + 2, h + N + 3, { bg: "#ff0000" }, { isRefresh: false });
                }
              }
            }
            let j = parseInt(A[2] / I * 100)
              , R = parseInt(A[3] / I * 100)
              , P = "".concat(A[2].toString(), "/").concat(I.toString(), "(").concat(j.toString(), "%)")
              , L = "".concat(A[3].toString(), "/").concat(I.toString(), "(").concat(R.toString(), "%)");
            if (0 === T[t.length][e.length].value) {
              instance.api.setCellValue(m + 1, h, "0", { isRefresh: false });
            } else {
              instance.api.setCellValue(m + 1, h, T[t.length][e.length].value, { isRefresh: false });
              
            }
            instance.api.setCellValue(m + 1, h + 1, P, { isRefresh: false });
            instance.api.setCellValue(m + 1, h + 2, L, { isRefresh: false });
            m += 5;
          }
        }
      } else {
        instance.tooltip.info(proteinanalysismenuText.tooltipTitle, proteinanalysismenuText.Dnatips3);
      }
      instance.api.setRangeShow(range);
      seqDialog.hide();
      maskDialog.hide();
    }
    const id = "luckysheet-doubleSequenceComparison-dialog";
    instance.createHtmlDom.createDialog(id, content, containerId, locale_dnaAnalysis.doubleSequenceComparison, confirmCallback, true, true, true, '', '', '', true);
    let seqDialog = currentInstance.find(`#${id}`);
    // 选择序列单元格
    seqDialog.find("i").click(function() {
      const rangeSelect = "luckysheet-range-selector-dialog";
      let initVal = $(this).parent().find('input').val();
      let rangeValue = ''; // 判断如果是选择序列返回范围值，不是返回单元格坐标
      seqDialog.hide();
      instance.createHtmlDom.createRangeSelectorDialog(rangeValue);
      rangeDialog = currentInstance.find(`#${rangeSelect}`);
      rangeDialog.find('range-val').val(initVal);
      rangeDialog.find('.cancel-icon').click(() => {
        rangeDialog.hide();
        maskDialog.show();
        seqDialog.show();
      });
      rangeDialog.find('.ok-icon').click(() => {
        rangeDialog.hide();
        maskDialog.show();
        seqDialog.show();
        let rangeSelectorVal = rangeDialog.find('.range-val').val();
        $(this).parent().find('input').val(rangeSelectorVal);
      });
    });
    
  },
  /**
   * 获取分值
   * @param {*} e 
   * @param {*} t 
   * @param {*} n 
   * @param {*} r 
   * @returns 
   */
  getScore(e, t, n, r) {
    return e > 0 && 0 === t ? -299792458 : t > 0 ? n + r * t : 0;
  },
  /**
   * 获取序列对比矩阵
   * @param {*} e 
   * @param {*} t 
   * @param {*} n 
   * @param {*} r 
   * @param {*} i 
   * @param {*} o 
   * @returns 
   */
  getMatrix(e, t, n, r, i, o) {
    function A() {
      this.value,
      this.tracebackColumn,
      this.tracebackRow,
      this.tracebackMatrix
    }
    const _this = this;
    let a = [], s = [], c = t.length, l = e.length;
    for (let f = 0; f < c + 1; f++) {
        a[f] = [],
        s[f] = [];
      for (let d = 0; d < l + 1; d++){
        a[f][d] = _this.getScore(f, d, i, o);
        s[f][d] = _this.getScore(d, f, i, o);
      }    
    }
    let p = function (e, t) {
      let n = t.length, r = e.length, i = new Array(n + 1);
      for (let o = 0; o < n + 1; o++) {
        i[o] = new Array(r + 1);
        for (let a = 0; a < r + 1; a++){
          i[o][a] = new A;
        }
      }
      for (let s = 0; s < n + 1; s++){
        for (let c = 0; c < r + 1; c++){
          if (0 === c && 0 === s) {
            i[s][c].value = 0;
          } else {
            if (0 === c || 0 === s) {
              i[s][c].value = -299792458;
              if (0 === c) {
                i[s][c].tracebackColumn = 0;
                i[s][c].tracebackRow = s - 1;
                i[s][c].tracebackMatrix = "m";
              } else { ;
                i[s][c].tracebackColumn = c - 1;
                i[s][c].tracebackRow = 0;
                i[s][c].tracebackMatrix = "m";
              }
            } else {
              i[s][c].value = 0;
            }
          }
        }
      }
      return i;
    }(e, t);
    for (let m = 1; m < t.length + 1; m++){
      for (let y = 1; y < e.length + 1; y++) {
        let g = t[m - 1] === e[y - 1] ? n : r;
        switch (a[m][y] = Math.max.apply(null, [a[m][y - 1] + o, p[m][y - 1].value + i + o]),
        s[m][y] = Math.max.apply(null, [s[m - 1][y] + o, p[m - 1][y].value + i + o]),
        p[m][y].value = Math.max.apply(null, [a[m][y], s[m][y], g + p[m - 1][y - 1].value]),
        p[m][y].value) {
        case g + p[m - 1][y - 1].value:
            p[m][y].tracebackColumn = y - 1,
            p[m][y].tracebackRow = m - 1,
            p[m][y].tracebackMatrix = "m";
            break;
        case s[m][y]:
            p[m][y].tracebackColumn = y,
            p[m][y].tracebackRow = m - 1,
            p[m][y].tracebackMatrix = "y";
            break;
        case a[m][y]:
            p[m][y].tracebackColumn = y - 1,
            p[m][y].tracebackRow = m,
            p[m][y].tracebackMatrix = "x"
        }
      }
    }
    return p;
  },
  /**
   * 获取序列数组
   * @param {*} e 
   * @param {*} t 
   * @param {*} n 
   * @returns 
   */
  getSequenceList(e, t, n) {
    let r = t.length, i = e.length, o = "", a = "", s = 0, c = 0;
    for (c = 0; r > 0 || i > 0; ) {
        let u = r
          , l = i;
        switch (n[u][l].tracebackMatrix) {
        case "m":
            r = n[u][l].tracebackRow,
            i = n[u][l].tracebackColumn,
            o += e[l - 1],
            a += t[u - 1],
            e[l - 1] === t[u - 1] && (s += 1);
            break;
        case "y":
            r = n[u][l].tracebackRow,
            i = n[u][l].tracebackColumn,
            o += "-",
            a += t[u - 1],
            c += 1;
            break;
        case "x":
            r = n[u][l].tracebackRow,
            i = n[u][l].tracebackColumn,
            o += e[l - 1],
            a += "-",
            c += 1
        }
    }
    return [o = o.split("").reverse().join(""), a = a.split("").reverse().join(""), s, c];
  },
  /**
   * BLAST序列对比
   */
  BLASTSequenceComparison: function(){
    window.open('https://blast.ncbi.nlm.nih.gov/Blast.cgi?PROGRAM=blastn&PAGE_TYPE=BlastSearch&BLAST_SPEC=&LINK_LOC=blasttab&QUERY=AATGATGTAA')
  },
  /**
   * DNA序列复制
   */
  DNASequenceCopy() {
    let _this = this;
    const instance = _this.instance;
    const containerId = instance.getInstanceId();
    const currentInstance = $(`#${containerId}`);
    const maskDialog =  currentInstance.find("#luckysheet-modal-dialog-mask");
    const _locale = instance.locale();
    const copySeqmenuText = _locale.copySeqmenu;
    const range = instance.api.getRange();
    const column = range[range.length - 1].column;
    const row = range[range.length - 1].row;
    const a = row.length > 0 ? row[0] : 0,
      s = row.length > 1 ? row[1] : 0,
      sColumn = column.length > 0 ? column[0] : 0,
      eColumn = column.length > 0 ? column[1] : 0;
    let e = [], t = 1 ;
    // 获取DNA序列
    for (let c = (sColumn, eColumn, a); c <= s; c++) {
      let u = _this.readEffectDNA(c, !0, "string", instance);
      u.length > 0 && e.push(u);
    }
    let l = e.join("");
    // 校验DNA序列的有效性
    for (let f = 0; f < l.length; f++){
      if (!_this.isDnaLetter(l[f])) {
        t = 0;
        break
      }
    }
    // 无效提示
    if (0 === t) return instance.tooltip.info(copySeqmenuText.tooltipTitle, copySeqmenuText.checkseqTip); 
    // dna反向互补链
    let d = _this.reverseComplementaryChain(l)
      // rna序列
      , p = _this.rnaSequence(l)
      // rna反向互补链
      , m = function(e) {
        return _this.rnaSequence(_this.reverseComplementaryChain(e))
      }(l)
      // 蛋白质翻译序列
      , y = _this.proteinSequence(l)
      // 反向蛋白质翻译序列
      , g = function(e) {
        return _this.proteinSequence(_this.reverseComplementaryChain(e))
      }(l)
    // DNA复制弹窗html
    let content = `<div class="Hydrophobicity-setting-block protein-copy-block">
      <div class="subtemplate_wrap" style="width:465px;height: auto;">
        <div id="sub_module_body" >
          <div class="info_session">
            <p>${copySeqmenuText.clickinfo}：</p>
          </div>
          <div class="save_part" id="seqitem">
            <div class="sequence" style="display: inline-grid; width: 239px">
              <label>${copySeqmenuText.dnaseq}:</label>
              <textarea class="sequence" id="seq1" readonly >${l}</textarea>
            </div>
            <div class="sequence" style="display: inline-grid; width: 220px">
              <label>${copySeqmenuText.rcdna}:</label>
              <textarea class="sequence" id="seq2" readonly >${d}</textarea>
            </div>
            <div class="sequence" style="display: inline-grid; width: 239px">
              <label>${copySeqmenuText.rna}:</label>
              <textarea class="sequence" id="seq3" readonly >${p}</textarea>
            </div>
            <div class="sequence" style="display: inline-grid; width: 220px">
              <label>${copySeqmenuText.rcrna}:</label>
              <textarea class="sequence" id="seq4" readonly >${m}</textarea>
            </div>
            <div class="sequence" style="display: inline-grid; width: 239px">
              <label>${copySeqmenuText.aaseq}:</label>
              <textarea class="sequence" id="seq5" readonly >${y}</textarea>
            </div>
            <div class="sequence" style="display: inline-grid; width: 220px">
              <label>${copySeqmenuText.rcaa}:</label>
              <textarea class="sequence" id="seq6" readonly >${g}</textarea>
            </div>
          </div>
        </div>
      </div>
    </div>`;
    const id = 'luckysheet-DnaCopy-dialog';
    const title = copySeqmenuText.copySeqmenu;
    instance.createHtmlDom.createDialog(id, content, containerId, title, null, true, true, false);
    let seqDialog = currentInstance.find(`#${id}`);  
    // 点击DNA序列复制
    seqDialog.find(`#seqitem`).on("click", "textarea", (function () {
      // 选中待复制的内容进行复制
      $(this).select();
      document.execCommand("copy");
      seqDialog.hide();
      maskDialog.hide();
      instance.tooltip.info(copySeqmenuText.tooltipTitle, copySeqmenuText.copysuccess + "!");
    }));
  },

  /**
   * 获取选区内需要进行转化大小写的有效DNA序列数据
   * @param {*} e 当前索引行
   * @param {*} t 校验判断
   * @param {*} n 数据类型
   * @param {*} instance 当前实例
   * @returns 
   */
  readEffectDNA(e, t, n, instance) {
    if(!instance) return;
    let range = instance.api.getRange();
    let column = range[range.length - 1].column;
    let row = range[range.length - 1].row;
    let r, i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
    c = (row.length > 0 ? row[0] : 0, row.length > 0 ? row[1] : 0, column.length > 0 ? column[0] : 0),
    u = column.length > 0 ? column[1] : 0;
    let l = "", f = /[0-9]+/, d = /[`~!@#]/im;
    r = !1 === t ? "*" : "";

    for (let p = c; p <= u; p++) {
      let m = (instance.api.getCellValue(e, p)||'').toString().replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/[\n\r]/g, "")
        , y = (instance.api.getCellValue(e + 1, p)||'').toString().replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/[\n\r]/g, "");
      if ("Axis" !== m && !0 !== f.test(m) && !0 !== d.test(m) && "Axis" !== y) {
        for (var g = 0; g < m.length; g++){
          !1 === this.isDnaLetter(m[g]) && !0 === o ? l += r : l += !0 === i ? m[g] : m[g].toUpperCase();
        }
      }else {
        l += r;
      }    
    }
    return "string" === n ? l : "array" === n ? l.split("") : void 0;
  },
  
  /**
   * 是否dna序列中的字母
   * @param {*} e 校验值
   * @returns 
   */
  isDnaLetter(e) {
    let DNAFormat = ["A", "T", "G", "C", "N", "X", "-"];
    return -1 < DNAFormat.indexOf(e.toUpperCase());
  },
  /**
   * 反向互补链计算
   * @param {*} e 计算序列
   * @returns 
   */
  reverseComplementaryChain(e) {
    const  reverseComplementaryMap = new Map([["A","T"],["T","A"],["C", "G"],["G","C"],["N","N"],["X","X"]]),
    t = e.length;
    let n = [];
    for (let r = 0; r < t; r++){
      if (e[r] === e[r].toUpperCase()) {
        n[t - r - 1] = reverseComplementaryMap.get(e[r])
      } else {
        n[t - r - 1] = d.get(e[r].toUpperCase()).toLowerCase();
      }
    }
    return n.join("");
  },
  /**
   * RNA序列
   * @param {*} e 计算序列
   * @returns 
   */
  rnaSequence(e) {
    const rnaSequenceMap = new Map([["T","U"],["t", "u"]]),
    t = e.length;
    let n = [];
    for (let r = 0; r < t; r++){
      rnaSequenceMap.get(e[r]) ? n[r] = rnaSequenceMap.get(e[r]) : n[r] = e[r];
    }
    return n.join("");
  },
  /**
   * 蛋白质翻译序列
   * @param {*} e计算序列
   * @returns 
   */
  proteinSequence(e) {
    const n = e.length;
    let t = [];
    for (let r = 0; r < n - 2; r += 3) {
      let i = [e[r].toUpperCase(), e[r + 1].toUpperCase(), e[r + 2].toUpperCase()].join("").toUpperCase().toString();
      t.push(this.abbreviation[i]),
      (i.indexOf("N") >= 0 || i.indexOf("X") >= 0 || i.indexOf("-") >= 0) && t.push("?")
    }
    return t.join("");
  },
  /**
   * 查找酶切位点
   */
  searchForEnzymeCleavageSites() {
    let _this = this;
    const instance = _this.instance;
    const _locale = instance.locale();
    const restrictionText = _locale.restriction;
    // 根据选区获取行列索引
    const range = instance.api.getRange();
    const column = range[range.length - 1].column;
    const row = range[range.length - 1].row;
    const n = row.length > 0 ? row[0] : 0,
      r = row.length > 1 ? row[1] : 0,
      i = column.length > 0 ? column[0] : 0,
      // 序列数组
      sqeList = [];
    // 获取查找酶切点的序列
    for (let a = n; a <= r; a++) {
      let c = sequenceCommon.readSelectedInformation(a, !0, "string", instance);
      if(c.length > 0) sqeList.push(c);
    }
    // 插入酶切点标题
    instance.api.setCellValue(n + 2, i,restrictionText.restrictionName, { isRefresh: false }),
    instance.api.setCellValue(n + 2, i + 1, restrictionText.restrictionSite, { isRefresh: false }),
    instance.api.setCellValue(n + 2, i + 2, restrictionText.restrictionSeq, { isRefresh: false });
    let u = 3;
    // 插入酶切点
    for (let l = 0; l < sqeList.length; l++){
      let f = sqeList[l].toString();
      for (let h = 0; h < f.length; h++){
        for (let d = 4; d < 18; d++) {
          let p = f.slice(h, h + d);
            // 当符合规则时，设置酶切位点
          if (p.length === d) {
            // 遍历酶切点列表  
            for (let m = 0; m < _this.restrictionList.length; m++){
              // 找到酶切点进行复制
              if (!0 === _this.restrictionList[m].test(p)) {
                instance.api.setCellValue(n + u, i, _this.restrictionNameList[m], { isRefresh: false });
                instance.api.setCellValue(n + u, i + 1, h + 1, { isRefresh: false });
                instance.api.setCellValue(n + u, i + 2, p, { isRefresh: false });
                u += 1;
              }
            }
          }
        }
      }             
    }   
    // 刷新设定值，让值显示，节约资源
    instance.api.refresh();
    instance.api.setRangeShow(range);
  },
  /**
   * 环视DNA可视化
   */
  visualizationOfDNAbyLookingAround() {
    
  },
}
export default dnaAnalysisUtils;